import React, { useEffect, useState, useRef } from 'react';

import styles from './values.module.less';

import smorgaImageUrls from '~/client/lib/employee-branding/values-module-image-carousel-content';

const ValuesImageCarousel = () => {
  const delay = 6000;
  const [position, setPosition] = useState(0);
  const intervalId = useRef(null);

  useEffect(() => {
    intervalId.current = setInterval(
      () =>
        setPosition((prevPosition) =>
          prevPosition === smorgaImageUrls.length - 1 ? 0 : prevPosition + 1
        ),
      delay
    );
    return () => {
      clearInterval(intervalId.current);
    };
  }, []);

  return (
    <div className={styles.valuesSmorgaCarouselOuter}>
      <div
        className={styles.valuesSmorgaCarouselInner}
        style={{ transform: `translate3d(${-position * 100}%, 0, 0)` }}
      >
        {smorgaImageUrls.map((smorgaImageUrl) => (
          <div
            className={styles.valuesSmorgaDesktopImage}
            style={{ backgroundImage: `url(${smorgaImageUrl})` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ValuesImageCarousel;
